import SkuFamily from './SkuFamily';

export default SkuFamily;
